import { useAppSelector } from "@/store/store";
import { userSelector } from "@/store/slices/auth/selectors";

import { useDispatch } from "react-redux";
import { actionAcknowledgeProfile, actionSetUser } from "@/store/slices/auth";
import { actionSetLogout } from "@/store/slices/auth";
import { api, getEndpoint } from "@/api";
import { getUrlWithQueryParams } from "@/utils";
import React from "react";

const useAuth = () => {
  const user = useAppSelector(userSelector);
  const dispatch = useDispatch();

  const [loading, setLoading] = React.useState(false);

  const isRole = (role_name: string) => {
    if (!role_name) return false;
    if (!user?.roles?.length) return false;
    return user?.roles?.map((item) => item.name)?.includes(role_name);
  };

  // 🔥 refresh user with optional token
  const refreshUser = async () => {
    setLoading(true);
    try {
      const res = await api({
        method: "GET",
        url: getUrlWithQueryParams(getEndpoint("profile"), {
          expand: "media,roles",
        }),
      });

      const accessUser = res.data.data.item;
      dispatch(actionSetUser({ user: accessUser }));
      setLoading(false);
      return accessUser;
    } catch (err: any) {
      dispatch(actionSetLogout());
      window.location.href = `${process.env.REACT_APP_SEPEHRINO_LANDING}/login-sign-up`;
    }
  };

  const acknowledgeProfile = async () => {
    if (!user) return;
    await api({ method: "PATCH", url: getEndpoint("acknowledgeProfile") });
    dispatch(actionAcknowledgeProfile(user.id));
  };

  return { user, isRole, isLoggedIn: Boolean(user), refreshUser, acknowledgeProfile, loading };
};

export default useAuth;
